import script from "./question_answer.vue?vue&type=script&setup=true&lang=ts"
export * from "./question_answer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__